const XIcon = ({ ...params }) => {
  return (
    <svg
      width="24px"
      height="24px"
      {...params}
      xmlns="http://www.w3.org/2000/svg"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
      image-rendering="optimizeQuality"
      fill-rule="evenodd"
      clip-rule="evenodd"
      viewBox="0 0 512 509.64"
    >
      <rect width="24" height="24" rx="115.61" ry="115.61" />
      <path
        fill="#000"
        fill-rule="nonzero"
        d="M323.74 148.35h36.12l-78.91 90.2 92.83 122.73h-72.69l-56.93-74.43-65.15 74.43h-36.14l84.4-96.47-89.05-116.46h74.53l51.46 68.04 59.53-68.04zm-12.68 191.31h20.02l-129.2-170.82H180.4l130.66 170.82z"
      />
    </svg>
  );
};

const GmailIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Gmail"
      role="img"
      viewBox="0 0 512 512"
    >
      <rect width="24" height="24" rx="15%" fill="#ffffff" />
      <path d="M158 391v-142l-82-63V361q0 30 30 30" fill="#4285f4" />
      <path d="M 154 248l102 77l102-77v-98l-102 77l-102-77" fill="#ea4335" />
      <path d="M354 391v-142l82-63V361q0 30-30 30" fill="#34a853" />
      <path d="M76 188l82 63v-98l-30-23c-27-21-52 0-52 26" fill="#c5221f" />
      <path d="M436 188l-82 63v-98l30-23c27-21 52 0 52 26" fill="#fbbc04" />
    </svg>
  );
};

const InstagramIcon = () => {
  return (
    <svg height="24px" width="24px" version="1.1" id="Layer_1" viewBox="0 0 551.034 551.034">
      <g id="XMLID_13_">
        <linearGradient
          id="XMLID_2_"
          gradientUnits="userSpaceOnUse"
          x1="275.517"
          y1="4.5714"
          x2="275.517"
          y2="549.7202"
          gradientTransform="matrix(1 0 0 -1 0 554)"
        >
          <stop offset="0" style={{ stopColor: '#E09B3D' }} />
          <stop offset="0.3" style={{ stopColor: '#C74C4D' }} />
          <stop offset="0.6" style={{ stopColor: '#C21975' }} />
          <stop offset="1" style={{ stopColor: '#7024C4' }} />
        </linearGradient>
        <path
          id="XMLID_17_"
          style={{ fill: 'url(#XMLID_2_)' }}
          d="M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722
		c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156
		C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156
		c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722
		c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
        />

        <linearGradient
          id="XMLID_3_"
          gradientUnits="userSpaceOnUse"
          x1="275.517"
          y1="4.5714"
          x2="275.517"
          y2="549.7202"
          gradientTransform="matrix(1 0 0 -1 0 554)"
        >
          <stop offset="0" style={{ stopColor: '#E09B3D' }} />
          <stop offset="0.3" style={{ stopColor: '#C74C4D' }} />
          <stop offset="0.6" style={{ stopColor: '#C21975' }} />
          <stop offset="1" style={{ stopColor: '#7024C4' }} />
        </linearGradient>
        <path
          id="XMLID_81_"
          style={{ fill: 'url(#XMLID_3_)' }}
          d="M275.517,133C196.933,133,133,196.933,133,275.516
		s63.933,142.517,142.517,142.517S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6
		c-48.095,0-87.083-38.988-87.083-87.083s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083
		C362.6,323.611,323.611,362.6,275.517,362.6z"
        />

        <linearGradient
          id="XMLID_4_"
          gradientUnits="userSpaceOnUse"
          x1="418.306"
          y1="4.5714"
          x2="418.306"
          y2="549.7202"
          gradientTransform="matrix(1 0 0 -1 0 554)"
        >
          <stop offset="0" style={{ stopColor: '#E09B3D' }} />
          <stop offset="0.3" style={{ stopColor: '#C74C4D' }} />
          <stop offset="0.6" style={{ stopColor: '#C21975' }} />
          <stop offset="1" style={{ stopColor: '#7024C4' }} />
        </linearGradient>
        <circle
          id="XMLID_83_"
          style={{ fill: 'url(#XMLID_4_)' }}
          cx="418.306"
          cy="134.072"
          r="34.149"
        />
      </g>
    </svg>
  );
};

const FacebookIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        fill="#1877F2"
        d="M15 8a7 7 0 00-7-7 7 7 0 00-1.094 13.915v-4.892H5.13V8h1.777V6.458c0-1.754 1.045-2.724 2.644-2.724.766 0 1.567.137 1.567.137v1.723h-.883c-.87 0-1.14.54-1.14 1.093V8h1.941l-.31 2.023H9.094v4.892A7.001 7.001 0 0015 8z"
      />
      <path
        fill="#ffffff"
        d="M10.725 10.023L11.035 8H9.094V6.687c0-.553.27-1.093 1.14-1.093h.883V3.87s-.801-.137-1.567-.137c-1.6 0-2.644.97-2.644 2.724V8H5.13v2.023h1.777v4.892a7.037 7.037 0 002.188 0v-4.892h1.63z"
      />
    </svg>
  );
};

const TelegramIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_87_7225)" />
      <path
        d="M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_87_7225"
          x1="16"
          y1="2"
          x2="16"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#37BBFE" />
          <stop offset="1" stop-color="#007DBB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { FacebookIcon, GmailIcon, InstagramIcon, TelegramIcon, XIcon };
